import { render, staticRenderFns } from "./TabsSelector.vue?vue&type=template&id=b7cf596a&scoped=true&"
import script from "./TabsSelector.vue?vue&type=script&lang=js&"
export * from "./TabsSelector.vue?vue&type=script&lang=js&"
import style0 from "./TabsSelector.vue?vue&type=style&index=0&id=b7cf596a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cf596a",
  null
  
)

export default component.exports